import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormGroup, FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { customerConfig } from '@uxdf/direct-shared-lib';
import * as ParticipationAction from '../../../redux/actions/loyalty/actions-participation';

import { filter, tap } from 'rxjs/operators';
import { State } from '../../../redux/reducers';
import { LocationStrategy } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-loyalty-agents-participation',
  templateUrl: './loyalty-agents-participation.component.html',
  styleUrls: ['./loyalty-agents-participation.component.scss']
})
export class LoyaltyAgentsParticipationComponent implements OnInit, OnDestroy {
  // @loyaltyDocs: loyalty-agents-participation
  // This component confirms user participation in the loyalty system.

  readonly loyaltyAgentsParticipationBoxTitleString = $localize`:@@loyalty-agents-participation.boxTitle:Get your agents started on `;
  readonly loyaltyAmadeusPlusMeString = $localize`:@@loyalty-agents-participation.loyaltyAmadeusPlusMe:Amadeus+Me`;
  readonly loyaltyAgentsParticipationBenefitsMotivateString = $localize`:@@loyalty-agents-participation.benefitsMotivate:Motivate your staff`;
  readonly loyaltyAgentsParticipationBenefitsRewardString = $localize`:@@loyalty-agents-participation.benefitsReward:Reward their efforts`;
  readonly loyaltyAgentsParticipationBenefitsSaleString = $localize`:@@loyalty-agents-participation.benefitsSale:Increase your sales`;
  readonly loyaltyAgentsParticipationChangeParticipationNotesString = $localize`:@@loyalty-agents-participation.changeParticipationNotes:To remove access, `;
  readonly loyaltyAgentsParticipationChangeParticipationNotesLinkString = $localize`:@@loyalty-agents-participation.changeParticipationNotesLink:contact us`;
  readonly loyaltyAgentsParticipationCheckboxLabelString = $localize`:@@loyalty-agents-participation.checkboxLabel:I grant permission to my travel agents to access Amadeus+Me and agree to the `;
  public customerConfig$: Observable<any>;

  participationForm: FormGroup;
  loyaltyConfig$: Observable<{ customerConfig: any }>;
  isRequestSent = false;
  isLoading = true;
  termsLink: string;
  getContactUsLink: (label: string) => string;
  isSnow = false;
  private customerConfigSubscription: Subscription;

  constructor(private readonly store: Store<State>, private readonly location: LocationStrategy) {}

  ngOnInit() {
    this.participationForm = new FormGroup({
      participationAllowControl: new FormControl(null, Validators.required)
    });
    this.loyaltyConfig$ = this.store.pipe(
      select(customerConfig),
      filter(customer => !customer.isLoading),
      // loading on init and when request is sent and config has not been updated yet
      tap(customer => (this.isLoading = this.isRequestSent && !customer.customerConfig.loyalty_enabled_for_account))
    );
    this.termsLink = this.location.prepareExternalUrl('/content/registration-amadeus-plus-me-agreement');
    const contactUsLink = this.location.prepareExternalUrl('/contact');
    this.getContactUsLink = label => `<a href="${contactUsLink}">${label}</a>`;
    this.loyaltyConfig$ = this.store.pipe(
      select(customerConfig),
      filter(customer => !customer.isLoading),
      tap(customer => {
        const enabled = customer.customerConfig?.loyalty_enabled_for_account?? false;
        this.isLoading = this.isRequestSent && !enabled;

        if (enabled) {
          this.participationForm.get('participationAllowControl')?.setValue(true, { emitEvent: false });
          this.participationForm.get('participationAllowControl')?.disable();
        } else {
          this.participationForm.get('participationAllowControl')?.enable();
        }
      })
    );
    this.customerConfigSubscription = this.store.pipe(
        select(customerConfig)).subscribe(response => {
            this.isSnow = response.customerConfig.is_snow;
        });
  }

  approveParticipation() {
    this.isRequestSent = true;
    this.store.dispatch(new ParticipationAction.ApprovingParticipation());
  }

  ngOnDestroy() {
    if (this.customerConfigSubscription) {
      this.customerConfigSubscription.unsubscribe();
    }
  }
}
